import React from 'react';
import { ThemedText } from '../../../components';
import { parseCheckboxGroup, resolveOptionLabels } from '../parsers';

export default function BadgeListValue({ value, field, emptyValue = '—', theme }) {
  const options = field?.props?.options || field?.options || [];
  const labels = resolveOptionLabels(value, options);

  if (labels.length === 0) {
    return <ThemedText style={{ color: theme?.colors?.muted }}>None selected</ThemedText>;
  }
  return <ThemedText>{labels.join(', ')}</ThemedText>;
}
